module.exports = __webpack_public_path__ + "img/income-and-expense-log_B09JY6GTM1.8667b4c0.jpg";